module.exports = __webpack_public_path__ + "static/media/nueva_emma.5c5d7a90.png";